'use strict';

module.exports = function () {
    $(".pdp-description-more").click( function () {
        $(this).hide();
        $(this).siblings(".pdp-description-teaser").hide();
        $(this).siblings(".pdp-description-complete").show();
        $(this).siblings(".pdp-description-less").show();
    });
    $(".pdp-description-less").click( function () {
        $(this).hide();
        $(this).siblings(".pdp-description-teaser").show();
        $(this).siblings(".pdp-description-complete").hide();
        $(this).siblings(".pdp-description-more").show();
    });
}